import script from "./editGroupDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./editGroupDialog.vue?vue&type=script&lang=ts&setup=true"

import "./editGroupDialog.vue?vue&type=style&index=0&id=a6d481ee&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6d481ee"]])

export default __exports__